import React = require('react');
import { ServerSettingsUnauthenticated } from '~src/settings/services/ServerSettingsUnauthenticated';
import { DomainFamily } from '~src/settings/types/IServerSettingsUnauthenticated';
import { ExternalUsernameAndPasswordLogin } from './ExternalUsernameAndPasswordLogin';
import { LocalUsernameAndPasswordLogin } from './LocalUsernameAndPasswordLogin';
import { LoginPage } from './LoginPage';
import { RootLoginUiProps } from './RootLoginUi';
import { UsernameAndPasswordLoginForm } from './UsernameAndPasswordLoginForm';

export interface UsernameAndPasswordLoginProps extends RootLoginUiProps {
  initialUsername?: string;
  onUsernameChange?: (newUsername: string) => void;
  currentErrorCode?: number;
  children?: React.ReactNode;
}

export function UsernameAndPasswordLogin(props: UsernameAndPasswordLoginProps) {

  const domainFamily = ServerSettingsUnauthenticated.domainFamily();

  switch (domainFamily) {
    case DomainFamily.ActiveDirectory:
      return <LoginPage>
        <UsernameAndPasswordLoginForm {...props} />
        {props.children}
      </LoginPage>;
    case DomainFamily.External:
      return <ExternalUsernameAndPasswordLogin {...props} />;
    case DomainFamily.Local:
      return <LocalUsernameAndPasswordLogin {...props} />;
    default:
      throw new Error('Invalid domain family');
  }
}
